import { render, staticRenderFns } from "./addFollowLog.vue?vue&type=template&id=ba6cef0e&scoped=true"
import script from "./addFollowLog.vue?vue&type=script&lang=js"
export * from "./addFollowLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6cef0e",
  null
  
)

export default component.exports